import { getCookie } from "./Cookie";

export const TokenName = "XRAI_TOKEN";
export const TokenTime = 60 * 60 * 24;
export const handleModalController = ({
  windowWidth,
  setShowModal,
  setShowMobileModal,
  setLoginModal,
}) => {
  const token = getCookie(TokenName);

  if (!token) {
    setLoginModal(true);
    return;
  }

  if (windowWidth >= 701) {
    setShowModal(true);
  } else {
    setShowMobileModal(true);
  }
};

export const getTimeAgoText = (timeString) => {
  const now = new Date();
  const created = new Date(timeString);

  // ✅ 한국 시간으로 보정 (UTC+9)
  const kstCreated = new Date(created.getTime() + 9 * 60 * 60 * 1000);

  const diffMs = now.getTime() - kstCreated.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffMin < 1) return "방금 전";
  if (diffMin < 60) return `${diffMin}분 전`;
  if (diffHour < 24) return `${diffHour}시간 전`;
  return `${diffDay}일 전`;
};
